import React, { Component, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import TodaysReport from "../../Dashboard/TodaysReport";
import { getAllLocation } from "../../../actions/warehouseAction";
import {
    getAllEmployee,
} from "../../../actions/employeeAction";
import TodaysCashRegisterByPerson from "./TodaysCashRegisterByPerson";

import {
    Layout,
    Breadcrumb,
    Row,
    Col,
    DatePicker,
    TimePicker,
    Space,
    Select,
    Divider,
    Skeleton,
    Card,
    Button,
} from "antd";
const { Content } = Layout;
const { Meta } = Card;
const { Option } = Select;

const Dashboard = ({
    getAllLocation,
    getAllEmployee,
    Auth,
}) => {
    var currentdate = new Date();
    const [loading, setloading] = useState(true);
    const [reload, setreload] = useState(false);
    const [outletlist, setoutletlist] = useState([]);
    const [activeEmployee, setactiveEmployee] = useState([]);
    var datetime =
        currentdate.getFullYear() +
        "-" +
        (currentdate.getMonth() + 1) +
        "-" +
        currentdate.getDate() +
        "T00:00:00Z";
    var monthstart =
        currentdate.getFullYear() +
        "-" +
        (currentdate.getMonth() - 1) +
        "-" +
        "1" +
        "T00:00:00Z";
    const location = useRef(Auth.profile.branch.id);

    useEffect(() => {
        getAllLocation().then((result) => {
            setoutletlist(result);
            getAllEmployee(location.current).then((e) => {
                setactiveEmployee(e);
            });
        });
    }, [location.current]);

    const SwitchablePicker = () => {
        return Auth.superuser ||
            Auth.profile.user_role.id == 10 ||
            Auth.permissions.includes("Dashboard.Dashboard_is_location") ? (
            <Row>
                <Col span={24}>
                    <Space style={{ float: "right" }}>
                        Select a outlet:
                        <Select
                            placeholder="Please select a outlet"
                            style={{ width: "250px" }}
                            defaultValue={Auth.profile.branch.name}
                            onChange={(e) => {
                                location.current = e;
                                setreload(true);
                            }}
                        >
                            <Option value="">All</Option>
                            {outletlist.map((outlet) => {
                                if (!outlet.is_office && outlet.is_outlet)
                                    return <Option value={outlet.id}>{outlet.name}</Option>;
                            })}
                        </Select>
                    </Space>
                </Col>
            </Row>
        ) : (
            ""
        );
    };

    return (
        <>
            <Layout className="window-frame">
                <Sidebar />
                <Layout className="site-layout">
                    <Navbar />

                    <Content className="main-frame-content">
                        <div>
                            <Row>
                                <Col
                                    span={24}
                                    style={{ padding: "1rem", border: "1px solid whitesmoke" }}
                                >
                                    {SwitchablePicker()}
                                    <TodaysReport
                                        location={location}
                                        loading={loading}
                                        setloading={setloading}
                                        reload={reload}
                                        setreload={setreload}
                                    />

                                    <Row>

                                        {Auth.permissions.includes(
                                            "Sales.Add new order_is_read"
                                        ) ||
                                            Auth.permissions.includes(
                                                "Report.Sales report_is_read"
                                            ) ||
                                            Auth.superuser ? (
                                            <>
                                                {activeEmployee.map(emp => {
                                                    return <TodaysCashRegisterByPerson
                                                        key={emp.id}
                                                        emp={emp}
                                                        location={location}
                                                        loading={loading}
                                                        setloading={setloading}
                                                    />

                                                })}
                                            </>
                                        ) : null
                                        }

                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Content>

                </Layout >
            </Layout >
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        Auth: state.auth,
        allnotificationList: state.notifications.allnotificationList,
    };
};

export default connect(mapStateToProps, {
    getAllLocation,
    getAllEmployee,
})(Dashboard);
